export default __webpack_public_path__ + "static/media/background14.9cacbe11.svg";